

// export const baseUrl='http://localhost:5000/api';
// export const billBaseUrl = 'http://localhost:5000';
// export const  baseUrlEmail = 'http://localhost:5000/api';
// export const fileBaseUrl = 'http://localhost:5000';


// export const  baseUrlEmail = 'https://thanepolice.onrender.com/api';
// export const baseUrl='https://thanepolice.onrender.com/api';
// export const billBaseUrl = 'https://thanepolice.onrender.com';
// export const fileBaseUrl = 'https://thanepolice.onrender.com';



export const  baseUrlEmail = 'https://thanepolicerural.saavi.co.in/api';
export const baseUrl='https://thanepolicerural.saavi.co.in/api';
export const billBaseUrl ='https://thanepolicerural.saavi.co.in'
export const fileBaseUrl ='https://thanepolicerural.saavi.co.in'




